//
//  useCustomAuth.ts
//
//  isana.net,inc. Proprietary and Confidential
//

import { useState } from "react";
import { auth } from "../network/firebase";
import {
  GoogleAuthProvider,
  OAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { AuthType, AUTH_TYPE, MICROSOFT_TENANT_ID } from "../utils/env";
import { useNavigate } from "react-router-dom";

export const useCustomAuth = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  const decideProvider = () => {
    switch (AUTH_TYPE) {
      case AuthType.Google:
        return new GoogleAuthProvider();
      case AuthType.Microsoft:
        const provider = new OAuthProvider("microsoft.com");
        provider.setCustomParameters({ tenant: MICROSOFT_TENANT_ID });
        return provider;
    }
  };

  const handleSignIn = async () => {
    setError(null);
    try {
      const provider = decideProvider();
      await signInWithPopup(auth, provider);
      navigate("/AdminMain");
    } catch (_) {
      setError("認証に失敗しました。");
    }
  };

  return { handleSignIn, error };
};
